// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-builder {
  margin: 15px 0px;
  text-align: left;
}
.filter-builder .header {
  color: #7E8A8D;
  font-size: 16px;
  font-weight: 600;
}
.filter-builder .error-message {
  color: red;
  margin-top: 20px;
  font-weight: bold;
}
.filter-builder .sub-header {
  font-size: 14px;
  font-weight: 400;
  color: #363B3D;
  margin-top: 15px;
}
.filter-builder .filter-container {
  max-height: 22rem;
  overflow-y: auto;
  margin-top: 15px;
}
.filter-builder .filter-container .fa-icon {
  font-size: 12px;
  margin-right: 3px;
}
.filter-builder .filter-container .reset-btn-container {
  display: flex;
  justify-content: end;
}
.filter-builder .filter-container .reset-btn-container .reset-btn {
  border-radius: 25px;
  padding: 5px 20px;
  color: #7E8A8D !important;
  font-weight: 600;
  top: 3rem;
}
.filter-builder .filter-container .reset-btn-container .reset-btn:focus {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}
.filter-builder .filter-container .reset-btn-container .reset-btn:hover {
  background-color: #ffffff !important;
  border: none !important;
}
.filter-builder .filter-container .k-toolbar .k-input,
.filter-builder .filter-container .k-toolbar .k-picker {
  width: 15em;
}
.filter-builder .filter-container .k-toolbar-solid {
  border-color: #FFFFFF;
  background-color: #FFFFFF;
}
.filter-builder .filter-container .k-button {
  border: none !important;
  font-weight: 600;
  font-size: 14px;
}
.filter-builder .filter-container .k-button-solid-base.k-selected {
  background-color: #2F80ED;
  color: #FFFFFF;
}
.filter-builder .filter-container .k-toolbar-button-group,
.filter-builder .filter-container .k-toolbar-button {
  height: 38px;
  gap: 0px;
  color: #7E8A8D;
  background-color: #FFFFFF;
}
.filter-builder .filter-container div[aria-label="Filter expression row"] {
  background-color: #F4F5F5 !important;
  justify-content: normal;
}
.filter-builder .filter-container .k-picker-solid,
.filter-builder .filter-container .k-input-solid {
  background-color: white;
  color: #000000;
  font-weight: 600;
  border-color: #C9CECF;
  padding: 2px;
}
.filter-builder .filter-container .k-input-solid,
.filter-builder .filter-container .k-button-icon {
  color: #757575;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/FilterBuilder/index.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,gBAAA;AACJ;AACI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AACR;AAEI;EACI,UAAA;EACA,gBAAA;EACA,iBAAA;AAAR;AAGI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AADR;AAII;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;AAFR;AAIQ;EACI,eAAA;EACA,iBAAA;AAFZ;AAKQ;EACI,aAAA;EACA,oBAAA;AAHZ;AAKY;EACI,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AAHhB;AAKgB;EACI,wBAAA;EACA,2BAAA;EACA,uBAAA;AAHpB;AAMgB;EACI,oCAAA;EACA,uBAAA;AAJpB;AASQ;;EAEI,WAAA;AAPZ;AAUQ;EACI,qBAAA;EACA,yBAAA;AARZ;AAWQ;EACI,uBAAA;EACA,gBAAA;EACA,eAAA;AATZ;AAYQ;EACI,yBAAA;EACA,cAAA;AAVZ;AAaQ;;EAEI,YAAA;EACA,QAAA;EACA,cAAA;EACA,yBAAA;AAXZ;AAcQ;EACI,oCAAA;EACA,uBAAA;AAZZ;AAeQ;;EAEI,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AAbZ;AAgBQ;;EAEI,cAAA;EACA,gBAAA;AAdZ","sourcesContent":[".filter-builder {\n    margin: 15px 0px;\n    text-align: left;\n\n    .header {\n        color: #7E8A8D;\n        font-size: 16px;\n        font-weight: 600;\n    }\n\n    .error-message {\n        color: red;\n        margin-top: 20px;\n        font-weight: bold;\n    }\n\n    .sub-header {\n        font-size: 14px;\n        font-weight: 400;\n        color: #363B3D;\n        margin-top: 15px;\n    }\n\n    .filter-container {\n        max-height: 22rem;\n        overflow-y: auto;\n        margin-top: 15px;\n\n        .fa-icon {\n            font-size: 12px;\n            margin-right: 3px;\n        }\n\n        .reset-btn-container {\n            display: flex;\n            justify-content: end;\n\n            .reset-btn {\n                border-radius: 25px;\n                padding: 5px 20px;\n                color: #7E8A8D !important;\n                font-weight: 600;\n                top: 3rem;\n\n                &:focus {\n                    outline: none !important;\n                    box-shadow: none !important;\n                    border: none !important;\n                }\n\n                &:hover {\n                    background-color: #ffffff !important;\n                    border: none !important;\n                }\n            }\n        }\n\n        .k-toolbar .k-input,\n        .k-toolbar .k-picker {\n            width: 15em;\n        }\n\n        .k-toolbar-solid {\n            border-color: #FFFFFF;\n            background-color: #FFFFFF;\n        }\n\n        .k-button {\n            border: none !important;\n            font-weight: 600;\n            font-size: 14px;\n        }\n\n        .k-button-solid-base.k-selected {\n            background-color: #2F80ED;\n            color: #FFFFFF;\n        }\n\n        .k-toolbar-button-group,\n        .k-toolbar-button {\n            height: 38px;\n            gap: 0px;\n            color: #7E8A8D;\n            background-color: #FFFFFF;\n        }\n\n        div[aria-label=\"Filter expression row\"] {\n            background-color: #F4F5F5 !important;\n            justify-content: normal;\n        }\n\n        .k-picker-solid,\n        .k-input-solid {\n            background-color: white;\n            color: #000000;\n            font-weight: 600;\n            border-color: #C9CECF;\n            padding: 2px;\n        }\n\n        .k-input-solid,\n        .k-button-icon {\n            color: #757575;\n            font-weight: 500;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
